import { Platform } from 'react-native';
import User from '../data/user/User';

import * as SpecificLocalStorage from "../../specific/utils/LocalStorage";
import { doesFileExist, getOfflineUrl } from '../../specific/components/Download/DownloadButton';
import { wipeAsyncStorage } from './AsyncStorage/AsyncStorage';

// Méthode pour vérifier les adresses locales
export const getUrlsToUse = async (data: { urls: string[], activityKey: string, isAdaptedVersion?: boolean }) => {
    const { urls, activityKey, isAdaptedVersion = false } = data;
    if (Platform.OS !== "web") {
        let newUrls: string[] = [];
        for (const aUrlIndex in urls) {
            if (Object.prototype.hasOwnProperty.call(urls, aUrlIndex)) {
                const anUrl: string = urls[aUrlIndex];
                const urlToUse: string = await getUrlToUse({url:anUrl, activityKey, isAdaptedVersion});
                newUrls.push(urlToUse);
            }
        }
        return newUrls;
    }
    return urls;
}

export const getUrlToUse = async (data: { url: string, activityKey: string, isAdaptedVersion?: boolean }) => {
    const { url, activityKey, isAdaptedVersion = false } = data;
    if (Platform.OS !== "web") {
        const anOfflineUrl: string | null = getOfflineUrl({activity_key: activityKey, url});
        if ( anOfflineUrl !== null ) {
            const doesOfflineFileExist: boolean = await doesFileExist(anOfflineUrl);
            if (doesOfflineFileExist === true) {
                return "file://"+anOfflineUrl;
            }
        }
    }
    return url;
}

export const checkLocalUrls = (urls: string[]) => {
    if (Platform.OS !== "web") {
        let newUrls: string[] = [];
        for (const aUrlIndex in urls) {
            if (Object.prototype.hasOwnProperty.call(urls, aUrlIndex)) {
                const anUrl: string = urls[aUrlIndex];

                if (anUrl.indexOf("/Documents/") !== -1) {
                    const newLocalUrl = checkLocalUrl(anUrl);
                    newUrls.push(newLocalUrl);
                } else {
                    newUrls.push(anUrl);
                }
            }
        }
        return newUrls;
    }
    return urls;
}

export const checkLocalUrl = (url: string) => {
    if (Platform.OS !== "web") {
        if (url.indexOf("/Documents/") !== -1) {
            const newLocalUrl = SpecificLocalStorage.checkLocalUrl(url);
            return newLocalUrl;
        }
    }
    return url;
}

export const wipeData = async () => {
    await wipeAsyncStorage();
    const user: User = User.getInstance();
    await user.deleteUser();
}
